import { Pathname } from "history";
import { match, matchPath } from "react-router";

import { Route } from "@/mk2/containers/Application/Application";
import { routes } from "@/mk2/router";
import { parsePathBackport } from "@/mk2/services/historyBackports";
import { BASE_URL } from "@/mk/settings";

export function computeRouteMatch(pathname: Pathname, route: Route): match<any> {
    if (!route.path) {
        // Ignore all catch routes
        return null;
    }

    return matchPath(pathname, {
        path: route.path,
        exact: true,
        // prepare for react-router v6 upgrade
        // that is case sensitive
        sensitive: true,
    });
}

export function isPWARoute(to: string) {
    // Remove BASE_URL from absolute links
    if (to.startsWith(BASE_URL)) {
        to = to.substring(BASE_URL.length);
    }

    if (to.startsWith("http")) {
        // Different hostname - always use <a>
        return false;
    }

    const parsed = parsePathBackport(to);

    // Check if we have a route for this URL
    for (const route of routes) {
        const match = computeRouteMatch(parsed.pathname, route);
        if (match) {
            return true;
        }
    }

    // no route matched
    return false;
}
